export default {
  movieDB: process.env.REACT_APP_API_URL,
  genreCategoryId: process.env.REACT_APP_GENRE_CATEGORY_ID,
  tagCategoryId: process.env.REACT_APP_TAG_CATEGORY_ID
};
